module.exports = __webpack_public_path__ + "static/logo-4d9ddd8997fc034c494e1908eb9a27fe.png";